import zoomSdk, { Apis, ConfigResponse, OnMessageEvent } from '@zoom/appssdk';

const CAPABILITIES: Apis[] = [
  'shareApp',
  'sendAppInvitationToAllParticipants',
  'bringAppToFront',
  'sendMessage',
  'onMessage',
  'expandApp',
  'sendAppToBackground',
  'onSendAppInvitation',
  'onParticipantChange',
  'getMeetingParticipants',
];

let configuration: Promise<ConfigResponse> | undefined;
let configuredBody: HTMLElement;
let configuredUrl: string;

export function configureZoomSdk(): Promise<ConfigResponse> {
  const currentUrl = window.location.href;
  if (configuration && configuredBody === document.body && configuredUrl === currentUrl) {
    return configuration;
  }

  configuredBody = document.body;
  configuredUrl = currentUrl;
  const attempt = zoomSdk.config({ capabilities: CAPABILITIES });
  configuration = attempt;
  attempt.catch(() => {
    if (configuration === attempt) configuration = undefined;
  });

  return attempt;
}

export function supportsZoomApi(config: ConfigResponse, api: Apis): boolean {
  return !config.unsupportedApis.includes(api);
}

type MessageHandler = (event: OnMessageEvent) => void;
const messageHandlers = new Set<MessageHandler>();
let messageListenerRegistered = false;

export function subscribeToZoomMessages(handler: MessageHandler): () => void {
  if (!messageListenerRegistered) {
    zoomSdk.onMessage((event) => messageHandlers.forEach((listener) => listener(event)));
    messageListenerRegistered = true;
  }

  messageHandlers.add(handler);
  return () => { messageHandlers.delete(handler); };
}

type ParticipantChangeHandler = () => void;
const participantChangeHandlers = new Set<ParticipantChangeHandler>();
let participantChangeListenerRegistered = false;

export function subscribeToParticipantChanges(handler: ParticipantChangeHandler): () => void {
  if (!participantChangeListenerRegistered) {
    zoomSdk.onParticipantChange(() => participantChangeHandlers.forEach((listener) => listener()));
    participantChangeListenerRegistered = true;
  }

  participantChangeHandlers.add(handler);
  return () => { participantChangeHandlers.delete(handler); };
}
